// emailTemplates.js

const createEmailTemplate = (content) => `
  <!DOCTYPE html>
  <html>
    <head>
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Crypto App Email</title>
    </head>
    <body style="margin: 0; padding: 0; background-color: #f8f9fa; font-family: 'Inter', Arial, sans-serif;">
      <table cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px; margin: 0 auto; background: white; border-radius: 8px; overflow: hidden; margin-top: 20px; margin-bottom: 20px; box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);">
        ${content}
      </table>
    </body>
  </html>
`;

const emailTemplates = {
  welcome: (userData) => createEmailTemplate(`
    <!-- Header -->
    <tr>
      <td style="background-color: #7517a7; padding: 24px; text-align: center;">
        <img src="your-logo.png" alt="Logo" style="height: 40px; margin-bottom: 16px;">
      </td>
    </tr>

    <!-- Content -->
    <tr>
      <td style="padding: 32px 24px;">
        <h1 style="color: #1a1a1a; font-size: 24px; margin: 0 0 16px 0;">Welcome to CryptoApp, ${userData.name}! 🚀</h1>
        <p style="color: #4a4a4a; font-size: 16px; line-height: 24px; margin: 0 0 24px 0;">
          Your journey into secure and seamless crypto transactions starts here.
        </p>
        
        <div style="background-color: #f8f9fa; border-radius: 8px; padding: 24px; margin-bottom: 24px;">
          <h2 style="color: #1a1a1a; font-size: 18px; margin: 0 0 16px 0;">Get Started in 3 Easy Steps:</h2>
          <div style="display: flex; align-items: center; margin-bottom: 12px;">
            <span style="background-color: #7517a7; color: white; border-radius: 50%; width: 24px; height: 24px; display: inline-flex; align-items: center; justify-content: center; margin-right: 12px;">1</span>
            <span style="color: #4a4a4a;">Complete your profile verification</span>
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 12px;">
            <span style="background-color: #7517a7; color: white; border-radius: 50%; width: 24px; height: 24px; display: inline-flex; align-items: center; justify-content: center; margin-right: 12px;">2</span>
            <span style="color: #4a4a4a;">Set up two-factor authentication</span>
          </div>
          <div style="display: flex; align-items: center;">
            <span style="background-color: #7517a7; color: white; border-radius: 50%; width: 24px; height: 24px; display: inline-flex; align-items: center; justify-content: center; margin-right: 12px;">3</span>
            <span style="color: #4a4a4a;">Make your first deposit</span>
          </div>
        </div>

        <a href="${process.env.APP_URL}/get-started" style="background-color: #7517a7; color: white; padding: 12px 24px; border-radius: 4px; text-decoration: none; display: inline-block; font-weight: 500;">Get Started</a>
      </td>
    </tr>
  `),

  passwordReset: (userData) => createEmailTemplate(`
    <!-- Header -->
    <tr>
      <td style="background-color: #7517a7; padding: 24px; text-align: center;">
        <img src="your-logo.png" alt="Logo" style="height: 40px;">
      </td>
    </tr>

    <!-- Content -->
    <tr>
      <td style="padding: 32px 24px;">
        <h1 style="color: #1a1a1a; font-size: 24px; margin: 0 0 16px 0;">Reset Your Password</h1>
        <p style="color: #4a4a4a; font-size: 16px; line-height: 24px; margin: 0 0 24px 0;">
          We received a request to reset your password. Use the button below to set up a new password. If you didn't request this, please ignore this email.
        </p>

        <div style="background-color: #f8f9fa; border-radius: 8px; padding: 24px; margin-bottom: 24px;">
          <p style="color: #4a4a4a; margin: 0;">
            <strong>Security Tip:</strong> Your password should be at least 8 characters long and include a mix of letters, numbers, and symbols.
          </p>
        </div>

        <a href="${userData.resetLink}" style="background-color: #7517a7; color: white; padding: 12px 24px; border-radius: 4px; text-decoration: none; display: inline-block; font-weight: 500;">Reset Password</a>
        
        <p style="color: #4a4a4a; font-size: 14px; margin-top: 24px;">
          This link will expire in 30 minutes for security reasons.
        </p>
      </td>
    </tr>
  `),

  transferAlert: (transferData) => createEmailTemplate(`
    <!-- Header -->
    <tr>
      <td style="background-color: #7517a7; padding: 24px; text-align: center;">
        <img src="your-logo.png" alt="Logo" style="height: 40px;">
      </td>
    </tr>

    <!-- Content -->
    <tr>
      <td style="padding: 32px 24px;">
        <h1 style="color: #1a1a1a; font-size: 24px; margin: 0 0 16px 0;">Transaction Alert</h1>
        
        <div style="background-color: #f8f9fa; border-radius: 8px; padding: 24px; margin-bottom: 24px;">
          <table style="width: 100%;">
            <tr>
              <td style="color: #4a4a4a; padding: 8px 0;">Amount:</td>
              <td style="color: #1a1a1a; font-weight: 500; text-align: right;">
                ${transferData.amount} ${transferData.currency}
              </td>
            </tr>
            <tr>
              <td style="color: #4a4a4a; padding: 8px 0;">Type:</td>
              <td style="color: #1a1a1a; font-weight: 500; text-align: right;">
                ${transferData.type}
              </td>
            </tr>
            <tr>
              <td style="color: #4a4a4a; padding: 8px 0;">Status:</td>
              <td style="color: #00875A; font-weight: 500; text-align: right;">
                Completed
              </td>
            </tr>
            <tr>
              <td style="color: #4a4a4a; padding: 8px 0;">Transaction ID:</td>
              <td style="color: #1a1a1a; font-weight: 500; text-align: right;">
                ${transferData.transactionId}
              </td>
            </tr>
          </table>
        </div>

        <a href="${process.env.APP_URL}/transactions" style="background-color: #7517a7; color: white; padding: 12px 24px; border-radius: 4px; text-decoration: none; display: inline-block; font-weight: 500;">View Transaction</a>
      </td>
    </tr>
  `),

  verifyEmail: (userData) => createEmailTemplate(`
    <!-- Header -->
    <tr>
      <td style="background-color: #7517a7; padding: 24px; text-align: center;">
        <img src="your-logo.png" alt="Logo" style="height: 40px;">
      </td>
    </tr>

    <!-- Content -->
    <tr>
      <td style="padding: 32px 24px;">
        <h1 style="color: #1a1a1a; font-size: 24px; margin: 0 0 16px 0;">Verify Your Email</h1>
        
        <p style="color: #4a4a4a; font-size: 16px; line-height: 24px; margin: 0 0 24px 0;">
          To ensure the security of your account, please verify your email address using the code below:
        </p>

        <div style="background-color: #f8f9fa; border-radius: 8px; padding: 24px; text-align: center; margin-bottom: 24px;">
          <span style="font-size: 32px; font-weight: 600; letter-spacing: 8px; color: #7517a7;">
            ${userData.verificationCode}
          </span>
        </div>

        <p style="color: #4a4a4a; font-size: 14px; margin: 24px 0 0 0;">
          This code will expire in 10 minutes. If you didn't request this verification, please ignore this email.
        </p>
      </td>
    </tr>
  `),
};

// Footer for all emails
const emailFooter = `
  <!-- Footer -->
  <tr>
    <td style="background-color: #f8f9fa; padding: 24px; text-align: center;">
      <p style="color: #4a4a4a; font-size: 14px; margin: 0 0 16px 0;">
        Need help? Contact our support team at support@cryptoapp.com
      </p>
      <div style="margin-bottom: 16px;">
        <a href="#" style="color: #7517a7; text-decoration: none; margin: 0 8px;">Terms</a>
        <a href="#" style="color: #7517a7; text-decoration: none; margin: 0 8px;">Privacy</a>
        <a href="#" style="color: #7517a7; text-decoration: none; margin: 0 8px;">Unsubscribe</a>
      </div>
      <p style="color: #4a4a4a; font-size: 12px; margin: 0;">
        © ${new Date().getFullYear()} CryptoApp. All rights reserved.
      </p>
    </td>
  </tr>
`;

module.exports = { emailTemplates, emailFooter };
